import _ from 'lodash';

/**
 * Build the rich `formFields`-shaped VIEW that the app's stateful section
 * components (UserDetailsForm, EquipmentSectionForm, …) read — a plain-object
 * snapshot so the component's `{ ...formFields }` spreads carry every cross-field
 * key exactly as the app's real bag does (a Proxy would break spreads — no own
 * keys). It covers BOTH nested-state modes:
 *   - flat-join leaf fields → `form.fieldStates[k]` as `{ value, isVisible, … }`;
 *   - sub-bag nested blobs → `form.values[k]` that are plain objects (e.g.
 *     equipment's `values['${package}additionalEquipmentVulcan']`), DEEP-CLONED
 *     so the component's in-place `_.set(fields, '${sectionKey}.${product}.value')`
 *     mutates a copy, not engine state (the change is then detected on write).
 * Other scalar ancillary values are passed through as-is.
 */
export const buildFormFieldsView = form => {
  const view = {};
  Object.keys(form.fieldStates || {}).forEach(k => {
    view[k] = { ...form.fieldStates[k] };
  });
  Object.keys(form.values || {}).forEach(k => {
    if (view[k] !== undefined) return; // leaf field already covered
    const v = form.values[k];
    view[k] =
      v && typeof v === 'object' && !Array.isArray(v) ? _.cloneDeep(v) : v;
  });
  return view;
};

export default buildFormFieldsView;
